// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--mVSAN";
export var c_header = "styles-module--c_header--VlI4w";
export var header = "styles-module--header--jYyj+";
export var logo = "styles-module--logo--u9dJj";
export var overlay = "styles-module--overlay--EV8q3";
export var portal = "styles-module--portal--DfeXv";